import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

const Kids = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      navigate('/Dessert');
    },
    onSwipedRight: () => {
      navigate('/Sharing');
    },
    trackMouse: true,
    delta: 50,
    trackTouch: true
  });

  const renderMenuSection = (items: any[]) => (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-4xl w-full shadow-lg mt-8">
      <ul className="space-y-6">
        {items.map((item, index) => (
          <MenuListItem
            key={`kids-${index}`}
            fr={item.fr}
            en={item.en}
            prixFr={item.prixFr}
            prixEn={item.prixEn}
            descFr={item.descFr}
            descEn={item.descEn}
            language={language}
          />
        ))}
      </ul>
    </div>
  );

  return (
    <div
      {...handlers}
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {renderMenuSection([
        {
          fr: "Mini Burger",
          en: "Mini Burger",
          prixFr: "16$",
          prixEn: "$16",
          descFr: "Petit burger de bœuf servi avec fromage et patates maison.",
          descEn: "Small beef burger served with cheese and homemade potatoes."
        },
        {
          fr: "Poulet Grillé",
          en: "Grilled Chicken",
          prixFr: "15$",
          prixEn: "$15",
          descFr: "Filet de poulet grillé accompagné de légumes et patates maison.",
          descEn: "Grilled chicken fillet served with vegetables and homemade potatoes."
        }
        ,
        {
          fr: "Mini Pizza",
          en: "Mini Pizza",
          prixFr: "11$",
          prixEn: "$11",
          descFr: "Mini pizza garnie de sauce tomate et fromage fondant.",
          descEn: "Mini pizza topped with tomato sauce and melted cheese."
        },
        {
          fr: "Egg Muffins",
          en: "Egg Muffins",
          prixFr: "12$",
          prixEn: "$12",
          descFr: "Egg muffins servis avec patates et salades.",
          descEn: "Egg muffins served with potatoes and salad."
        }
      ])}
    </div>
  );
};

const MenuListItem = ({ fr, en, prixFr, prixEn, descFr, descEn, language }: any) => (
  <li className="border-b border-gray-200 pb-6 last:border-0">
    <div className="flex justify-between items-start">
      <div>
        <h3 className="font-bold text-xl">{language === "fr" ? fr : en}</h3>
        <p className="text-gray-600 mt-1 text-sm">{language === "fr" ? descFr : descEn}</p>
      </div>
      <span className="text-green-950 font-medium text-lg whitespace-nowrap ml-4">
        {language === "fr" ? prixFr : prixEn}
      </span>
    </div>
  </li>
);

export default Kids;
